// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__ZbIUv","black":"title_black__sVvJD","white":"title_white__KRbg6"};